import axios from '@xpeng/union-login';
import type { AxiosRequestConfig } from 'axios';

const axiosInstance = axios({
  loginCodeList: [12150008, 12150005]
});

export type XDragonApiResponse<T> = {
  code: number;
  data: T;
  msg: string;
  record?: string;
};

export type XDragonApiResponsePromise<T> = Promise<XDragonApiResponse<T>>;

/**
 * 语言 header 供应者 —— 由入口文件通过 setLanguageProvider 注入。
 * 避免直接 import store 造成 ajax -> store -> models -> api/... -> ajax 循环依赖。
 */
let languageProvider: (() => string | undefined) | undefined;

export function setLanguageProvider(fn: () => string | undefined) {
  languageProvider = fn;
}

/**
 * 读取当前语言 —— 用于接口需要把 language 塞进 request body 的场景
 * （例如 listArticlePage / getArticleDetail 后端不仅要 header，也要 body 里的 language）。
 */
export function getLanguage(): string | undefined {
  return languageProvider?.();
}

export function ajax<T = any>(config: AxiosRequestConfig): XDragonApiResponsePromise<T> {
  if (!config.method) {
    config.method = 'get';
  }
  const request = axiosInstance[config.method.toLowerCase()];
  if (!request) {
    throw new Error(`Unsupported request method: ${config.method}`);
  }
  const extraConfig: AxiosRequestConfig = { timeout: 30000 };

  // 后端多个接口用 @RequestHeader('language') 必填校验（含 listSecondChannels /
  // listArticlePage / getArticleDetail / service/v1/file/operate/download 等），
  // 缺失会返回 "Missing request header 'language'"。这里从 Redux LocaleModel 拿
  // serverLang 自动注入；调用方显式在 config.headers.language 传值则以显式为准。
  const mergedHeaders: Record<string, string> = {
    ...(config.headers as Record<string, string> | undefined)
  };
  if (!mergedHeaders.language) {
    const lang = languageProvider?.();
    if (lang) {
      mergedHeaders.language = lang;
    }
  }
  if (Object.keys(mergedHeaders).length > 0) {
    extraConfig.headers = mergedHeaders;
  }

  return request.call(axiosInstance, config.url, config.data, extraConfig);
}
